import { render, staticRenderFns } from "./CompanyIndex.vue?vue&type=template&id=60c3d922&scoped=true&"
import script from "./CompanyIndex.vue?vue&type=script&lang=js&"
export * from "./CompanyIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIndex.vue?vue&type=style&index=0&id=60c3d922&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c3d922",
  null
  
)

export default component.exports